export enum SaveType {
  Draft,
  ForApproval,
  Publish,
}

export const SAVE_TYPE_ROUTE: any = {
  [SaveType.Draft]: 'draft',
  [SaveType.ForApproval]: 'forApproval',
  [SaveType.Publish]: 'published',
};
